<script setup>
import { onMounted, ref, reactive, nextTick } from "vue";
import moment from "moment";
import YTOrderState from "@/components/YTOrderState/index.vue"
import { userTokenStore } from "@/store/store.js";
import axios from "axios";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import { listMerchandiseOrder } from "@/api/competition/competition.js";
import { itemList } from '@/api/goods/goods.js';
import {getRoute} from "@/hooks/getRoute.js";
import {vipLevelEnum} from "@/enum/vipLevelEnum.js";
import {orderStateEnum} from "@/enum/orderStateEnum.js";

const {route} = getRoute()

/*初次加载*/
onMounted(async () => {
  await handleSearch('init', route.query.competitionGoodsId)
})

/*搜索功能*/
// 表单数据
const formData = reactive({
  userId: null,
  orderNo: null,
  nickname: null,
  phone: null,
  paymentStartTime: null,
  paymentEndTime: null,
  goodsId: null,
  time: [],
});
const pageGoods = ref(1)
const pageSizeGoods = ref(10)
const totalGoods = ref(0)
// 清空表单内容
const handleReset = () => {
  formData.userId = null
  formData.orderNo = null
  formData.nickname = []
  formData.phone = null
  formData.paymentStartTime = null
  formData.paymentEndTime = null
  formData.goodsId = null
  formData.time = []
  handleSearch('btnSearch')
}
// 表单锚点
const ruleFormRef = ref()
// 根据表单搜索信息
const handleSearch = async (mode = "init") => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const page = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    // 处理支付时间
    let param = {
      userId: formData.userId,
      orderNo: formData.orderNo,
      nickname: formData.nickname,
      phone: formData.phone,
      paymentStartTime: formData.time[0] ? moment(formData.time[0]).format('YYYY-MM-DD HH:mm:ss') : null,
      paymentEndTime: formData.time[1] ? moment(formData.time[1]).format('YYYY-MM-DD HH:mm:ss') : null,
      goodsId: formData.goodsId,
    }
    loading.value = true;
    // 搜索周边商品
    const res = await listMerchandiseOrder(page.value, route.query.competitionGoodsId, param);

    tableData.value = []
    tableData.value = flatOrderList(res.list)
    total.value = parseInt(res.total)
    spanArr.value = spanOrderList(tableData.value)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
const handleSearchGoods = async (query) => {
  try {
    const page = {
      page: pageGoods.value,
      pageSize: pageSizeGoods.value,
    }
    let param = {
      keyword: query,
    }
    goodsLoading.value = true;
    const res = await itemList(page, param);
    goodsList.value = res.list
    totalGoods.value = parseInt(res.total)
    goodsLoading.value = false
  } catch (e) {
    console.log(e)
    goodsLoading.value = false
  }
}
const handleChangeGoodsPage = async (e) => {
  pageGoods.value = e
  handleSearchGoods()
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
// 商品列表
const goodsList = ref([])
const goodsLoading = ref(false)
// 表格数据
const tableData = ref([])
const spanArr = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

// 周边订单表格合并单元格
const orderObjectSpanMethod = ({
  row,
  column,
  rowIndex,
  columnIndex,
}) => {
  if (columnIndex <= 6 || columnIndex > 10) {
    const _row = spanArr.value[rowIndex]
    const _col = spanArr.value[rowIndex] > 0 ? 1 : 0
    return [_row, _col]
  }
}

// 处理周边订单返回数据
const flatOrderList = (data) => {
  let result = []
  result = data.reduce((prev, curr) => {
    curr.orderItems.forEach(item => {
      prev.push({
        ...curr,
        ...item,
        orderNo: curr.orderNo,
        levelCode: curr.levelCode,
      })
    })
    return prev
  }, [])
  return result
}

// 获取周边订单合并数据
const spanOrderList = (data) => {
  let spanArr = []
  let pos = 0
  data.forEach((item, index) => {
    if (index === 0) {
      spanArr.push(1)
      pos = 0
    } else {
      if (item.orderNo === data[index - 1].orderNo) {
        spanArr[pos] += 1
        spanArr.push(0)
      } else {
        spanArr.push(1)
        pos = index
      }
    }
  })
  return spanArr
}

// 处理下载周边订单
const handleDownloadSurroundingOrder = () => {
  downloadFile(
    `${
      import.meta.env.VITE_API_URL
    }/competition/order/admin/downloadMerchandiseOrder/${route.query.competitionGoodsId}?userId=${formData.userId || ''}&orderNo=${formData.orderNo || ''}&nickname=${formData.nickname || ''}&phone=${formData.phone || ''}&paymentStartTime=${formData.time[0] ? moment(formData.time[0]).format('YYYY-MM-DD HH:mm:ss') : ''}&paymentEndTime=${formData.time[1] ? moment(formData.time[1]).format('YYYY-MM-DD HH:mm:ss') : ''}&goodsId=${formData.goodsId || ''}`,
    {}, // 请求体数据
    `${route.query.competitionGoodsName}周边订单-${moment().format(
      "YYYY-MM-DD_HHmmss"
    )}.csv` // 默认文件名
  );
}

/**
 * 自定义文件名的下载函数
 * @param {string} url - 完整接口URL
 * @param {Object} requestData - 请求体数据
 * @param {string} customFilename - 自定义文件名
 */
const downloadFile = async (url, requestData = {}, customFilename) => {
  try {
    const token = userTokenStore().token;
    const response = await axios.post(url, requestData, {
      responseType: "blob",
      headers: {
        Authorization: token.tokenValue,
        "Login-Type": token.loginType,
        "Content-Type": "application/json",
      },
      validateStatus: (status) => {
        if (status === 409) {
          ElMessage.error("数据列表为空,暂无数据导出")
          return false
        } else {
          return true
        }
      },
    })

    // 创建下载链接
    const blob = new Blob([response.data]);
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", customFilename); // 使用传入的自定义文件名
    document.body.appendChild(link);
    link.click();

    // 清理
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    }, 100);

    return true;
  } catch (error) {
    console.error("文件下载失败:", error);
    ElMessage.error("文件下载失败");
    return false;
  }
};
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 0">
    <el-form
      ref="ruleFormRef"
      style="text-align: left"
      :model="formData"
      label-width="auto"
      class="demo-ruleForm"
      status-icon
      label-position="left"
      inline
    >
      <div>
        <el-form-item label="用户ID：" prop="userId">
          <el-input v-model="formData.userId" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label="订单编号：" prop="orderNo">
          <el-input v-model="formData.orderNo" placeholder="请输入订单编号"></el-input>
        </el-form-item>
        <el-form-item label="用户昵称：" prop="nickname">
          <el-input v-model="formData.nickname" placeholder="请输入用户昵称"></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="phone">
          <el-input v-model="formData.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="支付时间：" prop="paymentStartTime">
          <el-date-picker
            v-model="formData.time"
            type="datetimerange"
            range-separator="至"
            start-placeholder="支付开始时间"
            end-placeholder="支付结束时间"
          />
        </el-form-item>
        <el-form-item label="商品名称：" prop="goodsId">
          <el-select
            v-model="formData.goodsId"
            filterable
            remote
            reserve-keyword
            placeholder="请选择商品名称"
            remote-show-suffix
            :remote-method="handleSearchGoods"
            :loading="goodsLoading"
            style="width: 240px"
          >
            <el-option
              v-for="item in goodsList"
              :key="item.goodsId"
              :label="item.goodsName"
              :value="item.goodsId"
            />
            <template #footer>
              <div class="flex_center">
                <el-pagination
                  size="small"
                  background
                  layout="prev, pager, next"
                  :total="totalGoods"
                  class="mt-4"
                  v-model:current-page="pageGoods"
                  v-model:page-size="pageSizeGoods"
                  @current-change="handleChangeGoodsPage"
                />
              </div>
            </template>
          </el-select>
        </el-form-item>
      </div>
    </el-form>
    <v-col cols="3">
      <v-row justify="start">
        <v-col class="flex_left" cols="6">
          <v-btn color="success" size="large" @click="handleSearch('btnSearch')" :disabled="false">搜索</v-btn>
        </v-col>
        <v-col class="flex_left" cols="6">
          <v-btn size="large" @click="handleReset" :disabled="false">重置</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </div>
  <div class="container_box">
    <div style="text-align: right;">
      <v-btn class="mg_b_2" color="success" :disabled="false" @click="handleDownloadSurroundingOrder">下载</v-btn>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%"
      :loading="loading"
      :span-method="orderObjectSpanMethod"
      stripe
    >
      <el-table-column prop="orderNo" label="订单编号" width="200"></el-table-column>
      <el-table-column prop="paymentTime" label="支付时间" width="200"></el-table-column>
      <el-table-column prop="userId" label="用户ID" width="200"></el-table-column>
      <el-table-column prop="phone" label="会员等级">
        <template #default="scope">
          {{ 
            vipLevelEnum.find(item => item.stateId === scope.row.levelCode)?.stateName
          }}
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="姓名" width="120"></el-table-column>
      <el-table-column prop="phone" label="联系手机号" width="120"></el-table-column>
      <el-table-column prop="goodsName" label="商品名称" width="200"></el-table-column>
      <el-table-column prop="quantity" label="商品数量"></el-table-column>
      <el-table-column prop="payableAmount" label="订单金额"></el-table-column>
      <el-table-column prop="orderItemState" label="支付状态">
        <template #default="scope">
          <!-- {{ 
            orderStateEnum.find(item => item.stateId === scope.row.orderItemState)?.stateName
          }} -->
          <YTOrderState :state="scope.row.orderItemState"></YTOrderState>
        </template>
      </el-table-column>
      <el-table-column prop="receiverInfo.receiverName" label="收货人" width="120"></el-table-column>
      <el-table-column prop="receiverInfo.receiverPhone" label="收货电话" width="120"></el-table-column>
      <el-table-column prop="receiverInfo.receiverAddress" label="收货地址" width="200"></el-table-column>
      <el-table-column prop="isPartialRefund" label="订单状态" fixed="right" width="120">
        <template #default="scope">
          {{ 
            scope.row.isPartialRefund ? '已完成（部分已退款）' : '已完成'
          }}
        </template>
      </el-table-column>
    </el-table>
    <YTTablePagination ref="YTTablePaginationRef" :pageSize="$globalPageSize" :total="total" @page-change="handleChangePage"></YTTablePagination>
  </div>
</template>

<style scoped>
::marker {
  content: none;
}
</style>